/**
 * @Description:
 * @Author: GaoSong
 */

import {isObject, cloneDeep, assign, isPlainObject, isUndefined, isNil} from 'lodash-es'
import moment from 'moment'
import NP from 'number-precision'
import i18n from './i18n'

const pageText = window.fe.getPageText(i18n)

const defaultValue = (value = '') => isNil(value) ? '' : value

const selectSubmit = (value, field, isEdit) => {
  if (!value) return ''
  if (!field.supportQuoteData && isEdit) {
    const id = value ? value.id : value
    return {
      id,
      updated: !!value._update
    }
  }
  return value?.id || ''
}

const nullSubmit = (value = '') => {
  return value === null ? '' : value
}

const getDateType = (dateFormat) => {
  const config = {
    'yyyy-MM': 'month',
    'yyyy-MM-dd': 'date',
    'yyyy-MM-dd HH:mm': 'datetime',
    'yyyy-MM-dd HH:mm:ss': 'datetime'
  }
  return config[dateFormat]
}

function getRandomNumber () {
  return parseInt(Math.random() * 1e10)
}

let fields = {
  'short-text': {
    tip: '',
    repeated: true,
    required: false,
    searchable: false, // 是否搜索
    mainField: false,
    readOnly: false,
    maxLength: 100,
    minLength: 2,
    region: 3,
    attr: {
      ruleConfig: {
        trigger: ['blur']
      },
      defaultValue: defaultValue,
      submitValue: defaultValue
    }
  },
  'text-area': {
    apiName: '',
    placeholder: 1,
    tip: '',
    repeated: true,
    required: false,
    searchable: false, // 是否进搜索
    region: 3,
    maxLength: 2000,
    minLength: 5,
    mainField: false,
    readOnly: false,
    attr: {
      ruleConfig: {
        trigger: ['blur']
      },
      defaultValue: defaultValue,
      submitValue: defaultValue
    }
  },
  'auto-number': {
    componentName: '自增编号',
    name: '自增编号',
    info: '系统按照规则自动生成编码，不可修改',
    icon: 'icon-zizengbianhao',
    type: 'autoNumber',
    apiName: '',
    version: 1,
    lifeStatus: 1,
    placeholder: 1,
    tip: '',
    repeated: false,
    required: false,
    searchable: false, // 是否进搜索
    region: 3,
    readOnly: true,
    readOnlyNotModify: true,
    digits: '2',
    prefix: '',
    startingVal: '1',
    suffix: '',
    mainField: false,
    recalculateRule: '',
    attr: {
      ruleConfig: {
        trigger: ['change']
      },
      defaultValue: defaultValue,
      submitValue: defaultValue
    }
  },
  'single-choice': {
    apiName: '',
    version: 1,
    uiComponent: 1,
    selectedShowStyle: 1,
    choiceValues: [
      {
        choiceValue: {
          value: pageText.theSampleOptions,
          choiceKey: 'option_sample'
        },
        state: false,
        isDefaultChoice: false
      }
    ],
    placeholder: 1,
    selectMaxLength: 2000,
    tip: '',
    repeated: true,
    required: false,
    searchable: false, // 是否进搜索
    region: 3,
    readOnly: false,
    mainField: false,
    attr: {
      ruleConfig: {
        trigger: ['change'],
        rules: {
          required: {
            msg: function (field) {
              return pageText.pleaseSelectA + field.name
            }
          }
        }
      },
      defaultValue: function (value = '', field, isEdit) {
        if (!isEdit && (value === '' || isNil(value) || isPlainObject(value))) {
          value = field.choiceValues.find(item => item.defaultChoice) || value
        }
        if (isNil(value)) {
          return ''
        }
        return isPlainObject(value) ? (value?.choiceValue?.choiceKey || value?.key) : String(value)
      },
      submitValue (val) {
        return !val ? null : val
      }
    }
  },
  'multiple-choices': {
    apiName: '',
    uiComponent: 1,
    selectedShowStyle: 1,
    choiceValues: [],
    lifeStatus: 1,
    placeholder: 1,
    selectMaxLength: 2000,
    tip: '',
    repeated: true,
    required: false,
    searchable: false, // 是否进搜索
    region: 3,
    readOnly: false,
    mainField: false,
    attr: {
      ruleConfig: {
        trigger: ['change'],
        rules: {
          required: {
            fieldDataType: function () {
              return 'array'
            },
            msg: function (field) {
              return pageText.pleaseSelectA + field.name
            }
          }
        }
      },
      defaultValue: function (_value = [], field, isEdit) {
        let value = _value || []
        if (!isEdit && (value.length === 0)) {
          let selected = field.choiceValues.filter(item => {
            return item.defaultChoice
          })
          return selected.map(item => {
            return item.choiceValue.choiceKey
          })
        }
        return value.map(item => item.key || item)
      },
      submitValue: defaultValue
    }
  },
  boole: {
    apiName: '',
    choiceValues: [
      {
        choiceValue: {
          value: 1,
          choiceKey: 1
        },
        state: false,
        isDefaultChoice: false
      },
      {
        choiceValue: {
          value: 2,
          choiceKey: 2
        },
        state: false,
        isDefaultChoice: true
      }
    ],
    placeholder: 1,
    tip: '',
    repeated: true,
    required: false,
    searchable: false, // 是否进搜索
    region: 3,
    readOnly: false,
    mainField: false,
    uiComponent: 1,
    attr: {
      ruleConfig: {
        trigger: ['change'],
        rules: {
          required: {
            msg: function (field) {
              return pageText.pleaseSelectA + field.name
            }
          }
        }
      },
      defaultValue: function (value, field, isEdit) {
        if (!isUndefined(value)) {
          return value
        }
        if (!isEdit) {
          let selected = field.choiceValues.find(item => item.defaultChoice)
          return selected ? selected.choiceValue.choiceKey : ''
        }
        if (typeof value === 'object') {
          return value ? value.key : ''
        }
        return value
      },
      submitValue: defaultValue
    }
  },
  number: {
    apiName: '',
    placeholder: 1,
    tip: '',
    repeated: true,
    integerMaxDigits: 10,
    decimalMaxDigits: 10,
    containMaxValue: true,
    containMinValue: true,
    minValue: 0,
    maxValue: 9999999999.9999999999,
    required: false,
    searchable: false, // 是否进搜索
    region: 3,
    readOnly: false,
    mainField: false,
    attr: {
      ruleConfig: {
        trigger: ['blur', 'change'],
        rules: {
          required: {
            fieldDataType: function (field) {
              if (field.uiType === 2) {
                return 'string'
              } else {
                return 'string'
              }
            },
            msg: function (field) {
              return pageText.pleaseEnter + field.name
            }
          }
        }
      },
      defaultValue: defaultValue,
      submitValue: nullSubmit
    }
  },
  percentage: {
    componentName: '百分数',
    name: '百分数',
    info: '用于输入和展示百分数',
    icon: 'icon-baifenshu',
    type: 'percentage',
    apiName: '',
    version: 1,
    lifeStatus: 1,
    placeholder: 1,
    tip: '',
    repeated: true,
    required: false,
    integerMaxDigits: 12,
    decimalMaxDigits: 8,
    containMaxValue: true,
    containMinValue: true,
    minValue: 0,
    maxValue: 999999999999.99999999,
    searchable: false, // 是否进搜索
    region: 3,
    readOnly: false,
    mainField: false,
    attr: {
      ruleConfig: {
        trigger: ['blur']
      },
      defaultValue: defaultValue,
      submitValue: (value, {props}) => {
        if ([undefined, null, ''].includes(value)) {
          return ''
        }
        return props.percentileValue
          ? NP.times(value, 100).toString()
          : value
      }
    }
  },
  currency: {
    componentName: '金额',
    name: '金额',
    info: '适用于填写数字,带千分位,比如订单金额',
    icon: 'icon-jine',
    type: 'currency',
    apiName: '',
    version: 1,
    lifeStatus: 1,
    placeholder: 1,
    tip: '',
    repeated: true,
    required: false,
    containMaxValue: true,
    containMinValue: true,
    minValue: 0,
    maxValue: 999.999,
    searchable: false, // 是否进搜索
    region: 3,
    integerMaxDigits: 3,
    decimalMaxDigits: 3,
    decimalDisplayDigits: 3,
    mainField: false,
    readOnly: false,
    attr: {
      ruleConfig: {
        trigger: ['blur']
      },
      defaultValue: value => value,
      submitValue: defaultValue
    }
  },
  date: {
    componentName: '日期',
    name: '日期',
    info: '用于选择特定日期',
    icon: 'icon-riqi1',
    type: 'date',
    apiName: '',
    version: 1,
    lifeStatus: 1,
    placeholder: 1,
    tip: '',
    repeated: true,
    required: false,
    searchable: false, // 是否进搜索
    region: 3,
    mainField: false,
    readOnly: false,
    isCanBeforeAddData: false,
    attr: {
      ruleConfig: {
        trigger: ['change']
      },
      defaultValue: function (value) {
        return value ? value.split(' ')[0] : ''
      },
      submitValue: nullSubmit
    }
  },
  'date-time': {
    componentName: '日期时间',
    name: '日期时间',
    info: '用于选择特定时刻',
    icon: 'icon-riqishijian',
    type: 'dateTime',
    apiName: '',
    version: 1,
    lifeStatus: 1,
    placeholder: 1,
    tip: '',
    repeated: true,
    required: false,
    searchable: false, // 是否进搜索
    region: 3,
    mainField: false,
    readOnly: false,
    isCanBeforeAddData: false,
    attr: {
      ruleConfig: {
        trigger: ['change']
      },
      defaultValue: defaultValue,
      submitValue: nullSubmit
    }
  },
  period: {
    componentName: '起止时间',
    name: '起止时间',
    info: '用于选择日期或时间范围',
    icon: 'icon-qizhishijian',
    type: 'period',
    apiName: '',
    version: 1,
    lifeStatus: 1,
    placeholder: 1,
    tip: '',
    repeated: true,
    required: false,
    searchable: false, // 是否进搜索
    region: 3,
    mainField: false,
    readOnly: false,
    isCanBeforeAddData: false,
    attr: {
      ruleConfig: {
        trigger: ['change'],
        rules: {
          required: {
            fieldDataType: function () {
              return 'object'
            },
            msg: function (field) {
              return pageText.pleaseSelectA + field.name
            }
          }
        }
      },
      defaultValue: function (value) {
        return value || {
          startTime: '',
          endTime: '',
          permanentSet: false
        }
      },
      submitValue (value = {}, field) {
        if (!value.startTime && !value.endTime && !value.permanentSet) {
          return ''
        }
        if (!field.permanentSet) {
          delete value.permanentSet
        }

        const dateType = getDateType(field.dateFormat)

        // 获取某一个月的总天数
        function getDaysOfMonth (year, month) {
          const date = new Date(year, month, 0)
          return date.getDate()
        }

        if (dateType === 'month' || dateType === 'date') {
          if (value.endTime) {
            let str = 'YYYY-MM-DD 23:59:59'
            const endTime = new Date(value.endTime)
            if (dateType === 'month') {
              const selectMLastDay = getDaysOfMonth(endTime.getFullYear(), endTime.getMonth() + 1)
              str = `YYYY-MM-${selectMLastDay} 23:59:59`
            }
            value.endTime = moment(endTime).format(str)
          }
          if (value.startTime) {
            value.startTime = moment(value.startTime).format('YYYY-MM-DD 00:00:00')
          }
        } else {
          if (value.startTime) {
            value.startTime = moment(value.startTime).format('YYYY-MM-DD HH:mm:ss')
          }
          if (value.endTime) {
            // 时分区间的时候 结束时间秒应该补位59不应该是00
            value.endTime = moment(value.endTime).format('YYYY-MM-DD HH:mm:ss')
          }
        }
        return value
      }
    }
  },
  'business-address': {
    componentName: pageText.addressField,
    info: pageText.businessAddressInfo,
    icon: 'icon-hangzhengquyu',
    type: 'businessAddress',
    lifeStatus: 1,
    mainField: false,
    supportQuoteData: false,
    name: pageText.addressField,
    region: 3,
    repeated: false,
    required: false,
    searchable: true,
    readOnly: true,
    isCanBeforeAddData: false,
    version: '1',
    attr: {
      ruleConfig: {
        trigger: ['blur', 'change'],
        rules: {
          required: {
            fieldDataType: function () {
              return 'object'
            },
            msg: function (field) {
              return pageText.pleaseSelectA + field.name
            }
          }
        }
      },
      defaultValue: defaultValue,
      submitValue: nullSubmit
    }
  },
  'sy-address': {
    componentName: pageText.addressField,
    info: pageText.thisFieldIsAssociated,
    icon: 'icon-hangzhengquyu',
    type: 'address',
    lifeStatus: 1,
    mainField: false,
    supportQuoteData: false,
    name: pageText.addressField,
    region: 3,
    repeated: false,
    required: false,
    searchable: true,
    readOnly: true,
    isCanBeforeAddData: false,
    version: '1',
    attr: {
      ruleConfig: {
        trigger: ['blur', 'change'],
        rules: {
          required: {
            validator: function (rule, value, callback) {
              if (!rule.required) {
                callback()
                return
              }
              if (!value || (isObject(value) && !value.id)) {
                callback(new Error(''))
              }
              callback()
            },
            fieldDataType: function () {
              return 'object'
            },
            msg: function (field) {
              return pageText.pleaseSelectA + field.name
            }
          }
        }
      },
      defaultValue (value = {}) {
        return value
      },
      submitValue: nullSubmit
    }
  },
  department: {
    componentName: '组织',
    name: '组织',
    info: '用于选择公司内指定组织',
    icon: 'icon-zuzhi',
    type: 'department',
    apiName: '',
    version: 1,
    creator: '',
    status: '',
    placeholder: 1,
    selectMaxLength: 5,
    tip: '',
    repeated: true,
    required: false,
    searchable: false, // 是否进搜索
    supportQuoteData: false,
    region: 3,
    createdTime: '',
    lifeStatus: '',
    isShow: true,
    mainField: false,
    readOnly: false,
    rowpoPageReadOnly: true,
    attr: {
      ruleConfig: {
        trigger: ['change'],
        rules: {
          required: {
            fieldDataType: function () {
              return 'object'
            },
            msg: function (field) {
              return pageText.pleaseSelectA + field.name
            }
          }
        }
      },
      defaultValue: defaultValue,
      submitValue (value = {}, field, isEdit) {
        return selectSubmit(value, field, isEdit)
      }
    }
  },
  personnel: {
    componentName: '人员',
    name: '人员',
    info: '用于选择公司内指定人员',
    icon: 'icon-renyuan',
    type: 'personnel',
    apiName: '',
    version: 1,
    creator: '',
    status: '',
    tip: '',
    placeholder: 1,
    selectMaxLength: 5,
    region: 3,
    repeated: true,
    required: false,
    searchable: false, // 是否进搜索
    supportQuoteData: false,
    createdTime: '',
    lifeStatus: '',
    isShow: true,
    mainField: false,
    readOnly: false,
    rowpoPageReadOnly: true,
    attr: {
      ruleConfig: {
        trigger: ['change', 'blur'],
        rules: {
          required: {
            validator: function (rule, value, callback) {
              if (rule.required && (!value || (isObject(value) && !value.id))) {
                callback(new Error(''))
              }
              callback()
            },
            msg: function (field) {
              return pageText.pleaseSelectA + field.name
            }
          }
        }
      },
      defaultParams: {
        queryStatus: 0
      },
      defaultValue: defaultValue,
      submitValue: selectSubmit
    }
  },
  quote: {
    componentName: '引用字段',
    name: '引用字段',
    info:
      '可以选择[1:多]关联对象中1方的同类型字段作为引用字段，展示其数据。例如:在客户销售订单-回款明细，可以在回款明细中新增字段展示销售订单或客户的某个字段信息',
    icon: 'icon-yinyongziduan',
    type: 'quote',
    version: 1,
    lifeStatus: 1,
    repeated: false,
    required: false,
    searchable: false,
    tip: '',
    placeholder: 1,
    region: 3,
    mainField: false,
    readOnly: false,
    attr: {
      defaultValue: defaultValue,
      // 引用字段 编辑页面 提交的字段重置为空字符串-jy
      submitValue (value, isEdit) {
        return isEdit ? '' : value
      }
    }
  },
  'sy-region': {
    componentName: '行政区域',
    name: '行政区域',
    info:
      '集成国家地址库的所有地址信息，使用地址字段可以记录省，市，区/县，街道/乡镇信息。',
    icon: 'icon-hangzhengquyu1',
    type: 'region',
    apiName: '',
    version: 1,
    tip: '',
    repeated: false,
    required: false,
    region: 3,
    mainField: false,
    readOnly: false,
    radio: true, // 是否多选
    showProvince: true, // 是否显示省
    showCity: true, // 是否显示市
    showCounty: true, // 是否显示县区
    showTown: true, // 是否显示街道镇
    searchable: false,
    attr: {
      defaultValue: defaultValue,
      ruleConfig: {
        trigger: ['blur', 'change'],
        rules: {
          required: {
            fieldDataType: function (field) {
              return field.radio ? 'object' : 'array'
            },
            msg: function (field) {
              return pageText.pleaseSelectA + field.name
            }
          }
        }
      },
      submitValue (value, field, isEdit) {
        if (field.radio && isEdit && value._update) {
          value.updated = true
        }
        return value
      }
    }
  },
  'master-detail-relationship': {
    componentName: '主从关联',
    name: '主从关联',
    icon: 'icon-zhucongguanlian',
    type: 'masterDetailRelationship',
    apiName: '',
    version: 1,
    tip: '',
    repeated: false,
    required: false,
    searchable: false,
    region: 3,
    mainField: false,
    readOnly: false,
    hiddenFieldHead: true, // 隐藏装修页面的可编辑头部
    hiddenFieldList: true, // 是否显示在装修页的字段列表里面
    attr: {
      ruleConfig: {
        trigger: ['change'],
        rules: {
          required: {
            fieldDataType: function () {
              return 'number'
            }
          }
        }
      },
      defaultValue: defaultValue,
      submitValue: defaultValue
    }
  },
  master_relation: {
    componentName: '主从关联',
    name: '主从关联',
    icon: 'icon-zhucongguanlian',
    type: 'master_relation',
    apiName: '',
    version: 1,
    tip: '',
    repeated: false,
    required: false,
    searchable: false,
    region: 3,
    mainField: false,
    pageFieldConf: {},
    readOnly: false,
    hiddenFieldList: true, // 是否显示在装修页的字段列表里面
    hiddenEditFieldList: true, // 是否显示新建字段的字段列表里面
    attr: {
      exclusiveLine: true,
      defaultValue: function () {
        return []
      },
      submitValue: defaultValue,
      showLabel: false,
      hideRule: true,
      ruleConfig: {
        trigger: ['change'],
        rules: {
          required: {
            fieldDataType: function (field) {
              return 'array'
            },
            validator: function (rule, value, callback) {
              if (value.length === 0) {
                return callback(new Error(''))
              }
              return callback()
            },
            msg: function (field) {
              if (field.subObjectInfo.verificationTips) {
                return field.subObjectInfo.verificationTips
              } else {
                return (
                  field.subObjectInfo.objectName + pageText.ObjectMustNotBeNull
                )
              }
            }
          }
        }
      }
    }
  },
  'lookup-relationship': {
    componentName: '查找关联',
    name: '查找关联',
    icon: 'icon-chazhaoguanlian',
    type: 'lookupRelationship',
    apiName: '',
    version: 1,
    tip: '',
    repeated: false,
    required: false,
    searchable: false,
    region: 3,
    mainField: false,
    readOnly: false,
    attr: {
      ruleConfig: {
        trigger: ['change'],
        rules: {
          required: {
            fieldDataType: function () {
              return 'number'
            }
          }
        }
      },
      defaultValue: (value) => {
        return value || {}
      },
      submitValue (value, {props}) {
        const key = props?.abilityResponseParams?.uniqueKey
        return value?.[key]
      }
    }
  },
  'sy-image': {
    componentName: '图片',
    name: '图片',
    info: '文件类型适用于上传图片，作为更生动的补充信息',
    icon: 'icon-tupian',
    type: 'image',
    fieldApiNameList: [],
    apiName: '',
    version: 1,
    tip: '',
    repeated: false,
    required: false,
    placeholder: 1,
    searchable: false,
    region: 3,
    mainField: false,
    readOnly: false,
    isDetail: true,
    isMultiFile: false,
    // 最大图片数量
    maxUploadNum: 1,
    // 单文件大小
    maxSize: 5,
    // 是否公开
    permission: 'open',
    attr: {
      ruleConfig: {
        trigger: ['change'],
        rules: {
          required: {
            fieldDataType: function () {
              return 'array'
            },
            msg: function (field) {
              return pageText.pleaseUpload + field.name
            }
          }
        }
      },
      defaultValue: function (value = []) {
        return value.map(item => {
          return {
            name: item.originalName,
            size: item.fileSize,
            fileUrl: item.fileUrl,
            openUrl: item.openUrl,
            uid: item.uid || getRandomNumber(),
            key: item.key
          }
        })
      },
      submitValue (value = []) {
        return value.map(item => {
          return {
            originalName: item.name,
            fileSize: item.size,
            fileUrl: item.filePath,
            openUrl: item.openUrl,
            key: item.key
          }
        })
      },
      requiredMssage: function () {
        return pageText.pleaseUploadPictures
      },
      column: {
        width: 270
      }
    }
  },
  'sy-file': {
    componentName: '文件',
    name: '文件',
    info:
      '文件类型适用于上传文件或图片，可设定文件上传格式和最多上传文件的数量',
    icon: 'icon-wenjian1',
    type: 'file',
    fieldApiNameList: [],
    apiName: '',
    version: 1,
    tip: '',
    repeated: false,
    required: false,
    placeholder: 1,
    searchable: false,
    region: 3,
    mainField: false,
    readOnly: false,
    isDetail: true,
    isMultiFile: false,
    // 是否公开
    permission: 'notopen',
    // 单文件大小
    maxSize: 5,
    // 文件格式
    format: [],
    // 最大文件数量
    maxUploadNum: 1,
    attr: {
      ruleConfig: {
        trigger: ['change'],
        rules: {
          required: {
            fieldDataType: function () {
              return 'array'
            },
            msg: function (field) {
              return pageText.pleaseUpload + field.name
            }
          }
        }
      },

      requiredMssage: function () {
        return pageText.pleaseUploadTheFile
      },
      defaultValue: function (value = []) {
        return value.map(item => {
          return {
            originalName: item.originalName || item.name,
            name: item.originalName || item.name,
            size: item.fileSize || item.size,
            filePath: item.fileUrl || item.filePath,
            fileUrl: item.fileUrl || item.filePath,
            uid: item.uid || getRandomNumber(),
            key: item.key
          }
        })
      },
      submitValue (value = []) {
        return value.map(item => {
          return {
            originalName: item.originalName || item.name,
            fileSize: item.size,
            fileUrl: item.filePath,
            key: item.key
          }
        })
      }
    }
  },
  'drop-down': {
    componentName: '通用下拉',
    name: '通用下拉',
    info:
      '文件类型适用于上传文件或图片，可设定文件上传格式和最多上传文件的数量',
    icon: 'icon-tongyongxiala',
    type: 'dropDown',
    apiName: '',
    version: 1,
    lifeStatus: 1,
    placeholder: 1,
    selectMaxLength: 2000,
    tip: '',
    repeated: true,
    required: false,
    searchable: false, // 是否进搜索
    region: 3,
    readOnly: false,
    mainField: false,
    attr: {
      ruleConfig: {
        trigger: ['change', 'blur'],
        rules: {
          required: {
            // fieldDataType: function () {
            //   return 'number'
            // },
            msg: function (field) {
              return pageText.pleaseSelectA + field.name
            }
          }
        }
      },
      defaultValue: defaultValue,
      submitValue: defaultValue
    }
  },
  'drop-down-tree': {
    componentName: '通用树形',
    name: '通用树形',
    info:
      '文件类型适用于上传文件或图片，可设定文件上传格式和最多上传文件的数量',
    icon: 'icon-tongyongshuxing',
    type: 'dropDownTree',
    apiName: '',
    version: 1,
    lifeStatus: 1,
    placeholder: 1,
    selectMaxLength: 2000,
    tip: '',
    repeated: true,
    required: false,
    searchable: false, // 是否进搜索
    region: 3,
    readOnly: false,
    mainField: false,
    attr: {
      ruleConfig: {
        trigger: ['change'],
        rules: {
          required: {
            fieldDataType: function () {
              return 'array'
            },
            msg: function (field) {
              return pageText.pleaseSelectA + field.name
            }
          }
        }
      },
      defaultValue (value = []) {
        return value
      },
      submitValue: defaultValue
    }
  },
  special: {
    componentName: '特殊字段',
    name: '特殊字段',
    info:
      '文件类型适用于上传文件或图片，可设定文件上传格式和最多上传文件的数量',
    icon: 'icon-teshuziduan',
    type: 'special',
    apiName: '',
    repeated: true,
    required: false,
    placeholder: 1,
    version: 1,
    region: 3,
    tip: '',
    readOnly: false,
    searchable: false,
    mainField: false,
    attr: {
      ruleConfig: {
        trigger: ['change']
      },
      defaultValue: defaultValue,
      submitValue: defaultValue
    }
  }
}

// 更新字段默认信息
export function updateDetailField (type, obj) {
  assign(fields[type], obj)
}

// 获取某个字段
export function getDetailField (type) {
  if (!type) {
    return new Error('type ' + 111)
  }
  let field = cloneDeep(fields[type]) || []
  return assign({}, field)
}

// 获取所有字段
export function getDetailAllField () {
  let _fields = {}
  Object.keys(fields).forEach(item => {
    _fields[item] = getDetailField(item)
  })
  return _fields
}

// 获取所有字段
export function getDetailAllFieldArray () {
  let _fields = []
  Object.keys(fields).forEach(item => {
    _fields.push(getDetailField(item))
  })
  return _fields
}
